import React, { useContext, useState } from 'react'
import { Context } from '../../../Store'
import { Grid, Typography, TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from './ErrorMessage'

export const Age = () => {
  const [state, dispatch] = useContext(Context)
  const [age, setAge] = useState(state?.age)
  const { t } = useTranslation()

  const onChangeAge = (event) => {
    const age = event.target.value === '' ? '' : Number(event.target.value)
    setAge(parseInt(age))
    dispatch({ type: 'SET_AGE', payload: parseInt(age) })
  }
  
  return (
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.userInfo.age.title')}</Typography>
      <TextField
        fullWidth
        name="age"
        type="number"
        variant="outlined"
        value={age}
        onChange={onChangeAge}
        label={t('booking.userInfo.age.placeholder')}
        inputProps={{ min: 18 }}
        onInput={(e) => {
          const el = e.target
          if (parseInt(el) < 18) el.value = 18;
        }}
        error={state?.error?.age}
      />
      {state?.error?.age && <ErrorMessage error={state?.error?.age} />}
    </Grid>
  )
}